module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-select",
    class: _vm.stateClasses,
    attrs: {
      "dir": _vm.dir
    }
  }, [_vm._t("header", null, null, _vm.scope.header), _vm._v(" "), _c('div', {
    ref: "toggle",
    staticClass: "vs__dropdown-toggle",
    attrs: {
      "id": ("vs" + _vm.uid + "__combobox"),
      "role": "combobox",
      "aria-expanded": _vm.dropdownOpen.toString(),
      "aria-owns": ("vs" + _vm.uid + "__listbox"),
      "aria-label": "Search for option"
    },
    on: {
      "mousedown": function($event) {
        return _vm.toggleDropdown($event)
      }
    }
  }, [_c('div', {
    ref: "selectedOptions",
    staticClass: "vs__selected-options"
  }, [_vm._l((_vm.selectedValue), function(option) {
    return _vm._t("selected-option-container", function() {
      return [_c('span', {
        key: _vm.getOptionKey(option),
        staticClass: "vs__selected"
      }, [_vm._t("selected-option", function() {
        return [_vm._v("\n                        " + _vm._s(_vm.getOptionLabel(option)) + "\n                    ")]
      }, null, _vm.normalizeOptionForSlot(option)), _vm._v(" "), (_vm.multiple) ? _c('button', {
        ref: "deselectButtons",
        refInFor: true,
        staticClass: "vs__deselect",
        attrs: {
          "disabled": _vm.disabled,
          "type": "button",
          "title": ("Deselect " + (_vm.getOptionLabel(option))),
          "aria-label": ("Deselect " + (_vm.getOptionLabel(option)))
        },
        on: {
          "click": function($event) {
            return _vm.deselect(option)
          }
        }
      }, [_c('i', {
        staticClass: "icon-close",
        staticStyle: {
          "font-size": "8px",
          "color": "#7b7a7a",
          "margin-right": "5px"
        }
      })]) : _vm._e()], 2)]
    }, {
      "option": _vm.normalizeOptionForSlot(option),
      "deselect": _vm.deselect,
      "multiple": _vm.multiple,
      "disabled": _vm.disabled
    })
  }), _vm._v(" "), _vm._t("search", function() {
    return [_c('input', _vm._g(_vm._b({
      staticClass: "vs__search"
    }, 'input', _vm.scope.search.attributes, false), _vm.scope.search.events))]
  }, null, _vm.scope.search)], 2), _vm._v(" "), _c('div', {
    ref: "actions",
    staticClass: "vs__actions"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showClearButton),
      expression: "showClearButton"
    }],
    ref: "clearButton",
    staticClass: "vs__clear",
    attrs: {
      "disabled": _vm.disabled,
      "type": "button",
      "title": "Clear Selected",
      "aria-label": "Clear Selected"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_c('i', {
    staticClass: "icon-close",
    staticStyle: {
      "font-size": "12px",
      "color": "#7b7a7a"
    }
  })]), _vm._v(" "), _vm._t("open-indicator", function() {
    return [(!_vm.noDrop) ? _c('span', {
      staticClass: "open-indicator caret",
      staticStyle: {
        "margin-right": "10px",
        "color": "#2f2e2ead"
      }
    }) : _vm._e()]
  }, null, _vm.scope.openIndicator), _vm._v(" "), _vm._t("spinner", function() {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mutableLoading),
        expression: "mutableLoading"
      }],
      staticClass: "vs__spinner"
    }, [_vm._v("Loading...")])]
  }, null, _vm.scope.spinner)], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [(_vm.dropdownOpen) ? _c('ul', {
    directives: [{
      name: "append-to-body",
      rawName: "v-append-to-body"
    }],
    ref: "dropdownMenu",
    staticClass: "vs__dropdown-menu",
    attrs: {
      "id": ("vs" + _vm.uid + "__listbox"),
      "role": "listbox"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.onMousedown.apply(null, arguments)
      },
      "mouseup": _vm.onMouseUp
    }
  }, [_vm._t("list-header", null, null, _vm.scope.listHeader), _vm._v(" "), _vm._l((_vm.filteredOptions), function(option, index) {
    return _c('li', {
      key: _vm.getOptionKey(option),
      staticClass: "vs__dropdown-option",
      class: {
        'vs__dropdown-option--selected': _vm.isOptionSelected(option),
        'vs__dropdown-option--highlight': index === _vm.typeAheadPointer,
        'vs__dropdown-option--disabled': !_vm.selectable(option)
      },
      attrs: {
        "role": "option",
        "id": ("vs" + _vm.uid + "__option-" + index),
        "aria-selected": index === _vm.typeAheadPointer ? true : null
      }
    }, [_vm._t("option", function() {
      return [_c('div', {
        staticClass: "dropdown-option"
      }, [_c('span', {
        on: {
          "mouseover": function($event) {
            _vm.selectable(option) ? _vm.typeAheadPointer = index : null
          },
          "mousedown": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.selectable(option) ? _vm.select(option) : null
          }
        }
      }, [_vm._v(_vm._s(_vm.getOptionLabel(option)))]), _vm._v(" "), _c('tooltip'), _vm._v(" "), (_vm.showClearOptionButton) ? _c('i', {
        directives: [{
          name: "popover",
          rawName: "v-popover:tooltip",
          value: ('Remove this email-address from the suggestion list.'),
          expression: "'Remove this email-address from the suggestion list.'",
          arg: "tooltip"
        }],
        staticClass: "icon-delete-1 delete-option",
        attrs: {
          "aria-hidden": "true"
        },
        on: {
          "click": function($event) {
            return _vm.deleteOption(option)
          }
        }
      }) : _vm._e()], 1)]
    }, null, _vm.normalizeOptionForSlot(option))], 2)
  }), _vm._v(" "), (_vm.filteredOptions.length === 0) ? _c('li', {
    staticClass: "vs__no-options"
  }, [_vm._t("no-options", function() {
    return [_vm._v("Sorry, no matching options.")]
  }, null, _vm.scope.noOptions)], 2) : _vm._e(), _vm._v(" "), _vm._t("list-footer", null, null, _vm.scope.listFooter)], 2) : _c('ul', {
    staticStyle: {
      "display": "none",
      "visibility": "hidden"
    },
    attrs: {
      "id": ("vs" + _vm.uid + "__listbox"),
      "role": "listbox"
    }
  })]), _vm._v(" "), _vm._t("footer", null, null, _vm.scope.footer)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6c56fbed!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/v-components/vue-select2/VSelect2.vue
// module id = 130
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 31 32